import React from 'react';

const CartBottomBar = ({ cart, showPage, activePage }) => {
    if (!cart || cart.length === 0 || activePage === 'cart' || activePage === 'payment') return null;

    const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
    const totalPrice = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);

    return (
        <div className="fixed bottom-0 md:bottom-4 left-0 right-0 md:left-auto md:right-4 z-50 p-4 md:p-0 md:w-96 mb-16 md:mb-0 transition-transform duration-300">
            <div className="bg-emerald-600 rounded-xl shadow-2xl p-4 flex items-center justify-between text-white cursor-pointer hover:bg-emerald-700 transition-colors" onClick={() => showPage('cart')}>
                <div className="flex flex-col">
                    <span className="font-bold text-lg">{totalItems} {totalItems === 1 ? 'Item' : 'Items'}</span>
                    <span className="text-sm font-semibold opacity-90">₹{totalPrice.toFixed(2)}</span>
                </div>
                <div className="flex items-center gap-3 font-bold bg-white/20 px-4 py-2 rounded-lg">
                    <span>View Cart</span>
                    <div className="relative">
                        <i className="fas fa-shopping-cart"></i>
                        <span className="absolute -top-3 -right-3 bg-red-500 text-white text-[10px] w-5 h-5 flex items-center justify-center rounded-full font-bold shadow-sm">
                            {totalItems}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartBottomBar;
